import {makeStyles} from "@material-ui/core";

export const useMainOfferContentStyles = makeStyles(() => ({
    zoneBox: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '2em',
    },
    zoneItem: {
        display: 'flex'
    },
    zoneItemIcon: {
        alignSelf: "baseline"
    }
}));
